import { commonRoutes } from '../commonRoutes';

export const WOW_ERA_ROUTES = {
  ...commonRoutes,

  Home: '/',
  Login: '/login',

  RealmHome: '/home/:region/:realm',
  RegionHome: '/home/:region',

  CharacterRankings: '/character-rankings/:type/:region/:realm/:faction/:class/:page?',

  OTKMakgoraRegistrationPage: '/events/otk-makgora/signups',

  LiveLoggedEncounterList: '/live/raid-encounters/:raid/:filter/:page?'
};

export type TWoweraRoutes = typeof WOW_ERA_ROUTES;
